/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import StripeConnectWarningDialog from '/client/src/components/dialogs/stripeNotIssetWarning';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import TicketPreview from './ticket';
import EventPageTicketPreviewEditMenuModal from './modal/editMenu';
import EventPageTicketPreviewThemeModal from './modal/theme';
import { withRouter } from 'react-router-dom';
import { GET } from '/client/src/api';
import { toast } from 'react-toastify';
import { ToastSuccessOptions } from '/client/src/constants/toast';
import 'react-toastify/dist/ReactToastify.css';

import './styles.scss';
import ReactTooltip from 'react-tooltip';

type PropsType = {
  match: {
    params: {
      tableTab?: string,
      eventId: string
    }
  },
  eventDetail?: {
    url_name: string,
    id: string
  }
};

const EventPageDesign = (props: PropsType): React.Element<'div'> => {
  const [isCheckStripeConnection, handleCheckStripeConnection] = React.useState(null);
  const [isShowStripeWarning, handleShowStripeWarning] = React.useState(true);
  const [isShowModal, handleShowAddModal] = React.useState(false);
  const [isShowEditModal, handleShowEditModal] = React.useState(false);
  const [isShowThemeModal, handleToggleThemeModal] = React.useState(false);
  const { params: { eventId } } = props.match;
  const context = React.useContext(EventDetailContainerContext);
  const [partsData, _upPartsData] = React.useState([]);
  const isReadonlyPermission = _.get(context, 'eventDetail.permission', 'Write') === 'Read';
  const [theme, upThemeData] = React.useState(_.get(context, 'eventDetail.splash_page.theme', 'Light'));
  const upPartsData = (data: any) => {
    _upPartsData(data);
  };

  const getEventTicketsAndDonationTotalAmount = (): number => {
    const eventDetail = context.eventDetail || props.eventDetail;
    const isSetDonations = _.get(eventDetail, 'is_set_donations', false);
    const tickets = _.get(eventDetail, 'tickets', []);
    const donations = _.get(eventDetail, 'donations', []);
    const ticketsTotal = tickets.reduce((p, c): number => p + c.price, 0);
    const donationsTotal = isSetDonations ? donations.reduce((p, c): number => p + (c.is_active ? c.prefilled_amount : 0), 0) : 0;

    return ticketsTotal + donationsTotal;
  };

  React.useEffect(() => {
    const eventItemsTotalAmount = getEventTicketsAndDonationTotalAmount();

    if (!(eventItemsTotalAmount > 0)) {
      handleCheckStripeConnection(true); // No need to connect Stripe
      return;
    }

    const fetchData = async () => {
      try {
        const { result } = await GET('/api/v1/1/merchants/paymentmethod/stripe_token_direct/settings');

        let isIssetAccount = false;

        _.map(result, (r: {}) => {
          if (_.size(r.connect_account_id)) {
            isIssetAccount = true;
          }
        });

        handleCheckStripeConnection(isIssetAccount);
      } catch (e) {
        console.log(e);
        console.error('Can\'t get settings');
      }
    };

    fetchData();
  }, []);

  const handleToggleModal = (status: boolean) => {
    handleShowAddModal(status);
  };

  const handleToggleEditModal = (status: boolean) => {
    handleShowEditModal(status);
  };

  const confirmStripeWarn = (status: boolean) => {
    handleShowStripeWarning(false);
  };

  const copyClipboard = () => {
    // eslint-disable-next-line max-len
    const copyText = `${process.env.EVENT_HOST}${context.eventDetail ? context.eventDetail.url_name : props.eventDetail.url_name}`;

    navigator.clipboard.writeText(copyText);

    toast.success('Event link copied to clipboard', ToastSuccessOptions());
  };

  return (
    <>
      <div className="splash-editor EventPageDesign">
        <div
          style={{
              boxShadow: '0 0 10px rgba(0,0,0,0.1)',
              background: isShowStripeWarning ? '#fff' : 'transparent'
            }}
        >
          <div className="splash-editor-header modal-header">
            <div className="row">
              <div className="col-md-8">
                <div className='textbox-wrapper'>
                  <div className="textbox">
                    {process.env.EVENT_HOST}{context.eventDetail ?
                    context.eventDetail.url_name :
                    props.eventDetail.url_name}
                  </div>
                  <button
                    className='btn textbox-action'
                    onClick={copyClipboard}
                    data-tip
                    data-for="copyClipboard_btn"
                  >
                    <ReactTooltip
                      id='copyClipboard_btn'
                      place='top'
                      effect='solid'
                    >
                      <span>Copy link</span>
                    </ReactTooltip>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="28"
                      width="28"
                      fill='#fff'
                      viewBox="0 0 48 48"
                    >
                      <path d="M9 43.95q-1.2 0-2.1-.9-.9-.9-.9-2.1V10.8h3v30.15h23.7v3Zm6-6q-1.2 0-2.1-.9-.9-.9-.9-2.1v-28q0-1.2.9-2.1.9-.9 2.1-.9h22q1.2 0 2.1.9.9.9.9 2.1v28q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h22v-28H15v28Zm0 0v-28 28Z"/>
                    </svg>
                  </button>
                  <a
                    href={`
                      ${process.env.EVENT_HOST}${context.eventDetail ? context.eventDetail.url_name
                      : props.eventDetail.url_name}
                      `}
                    className='btn textbox-action'
                    target='_blank'
                    data-tip
                    data-for="openNewTab_btn"
                  >
                    <ReactTooltip
                      id='openNewTab_btn'
                      place='top'
                      effect='solid'
                    >
                      <span>Open in new tab</span>
                    </ReactTooltip>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="28"
                      width="28"
                      fill='#fff'
                      viewBox="0 0 48 48"
                    >
                      <path d="M9 42q-1.2 0-2.1-.9Q6 40.2 6 39V9q0-1.2.9-2.1Q7.8 6 9 6h30q1.2 0 2.1.9.9.9.9 2.1v30q0 1.2-.9 2.1-.9.9-2.1.9H28.5v-3H39V12H9v27h10.5v3Zm13.5 0V27.8l-4.15 4.15-2.15-2.15L24 22l7.8 7.8-2.15 2.15-4.15-4.15V42Z"/>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="col-md-4">
                {
                  !isReadonlyPermission &&
                <div className="title pull-right">
                  <a
                    href="#"
                    className="btn btn-default"
                    data-tip
                    data-for="add_section_btn"
                    onClick={(e: any) => {
                      e.preventDefault();
                      handleToggleModal(true);
                    }}
                  >
                    <ReactTooltip
                      id='add_section_btn'
                      place='top'
                      effect='solid'
                    >
                      <span>Add new section</span>
                    </ReactTooltip>
                    <span className="icon icon-add" />
                  </a>
                  <a
                    href="#"
                    className="btn btn-default"
                    data-tip
                    data-for="menu_section_btn"
                    onClick={(e: any) => {
                      e.preventDefault();
                      handleToggleEditModal(true);
                    }}
                  >
                    <ReactTooltip
                      id='menu_section_btn'
                      place='top'
                      effect='solid'
                    >
                      <span>Edit menu</span>
                    </ReactTooltip>
                    <span className="icon icon-menu" />
                  </a>
                  <a
                    href="#"
                    className="btn btn-default"
                    data-tip
                    data-for="theme_section_btn"
                    onClick={(e: any) => {
                      e.preventDefault();
                      handleToggleThemeModal(true);
                    }}
                  >
                    <ReactTooltip
                      id='theme_section_btn'
                      place='top'
                      effect='solid'
                    >
                      <span>Edit theme</span>
                    </ReactTooltip>
                    <span className="icon icon-theme" />
                  </a>
                  <a
                    // eslint-disable-next-line
                    href={`${decodeURIComponent(`${process.env.EVENT_HOST}${context.eventDetail ? context.eventDetail.url_name : props.eventDetail.url_name}`).split(' ').join('-')}`}
                    className="btn btn-default"
                    rel="noreferrer noopener"
                    target='_blank'
                    data-tip
                    data-for="preview_section_btn"
                  >
                    <ReactTooltip
                      id='preview_section_btn'
                      place='top'
                      effect='solid'
                    >
                      <span>Preview</span>
                    </ReactTooltip>
                    <span className="icon icon-preview" />
                  </a>
                </div>
            }
              </div>
            </div>
          </div>

          {isShowStripeWarning && _.isNull(isCheckStripeConnection) ?
            <div className="panel-body csspinner" style={{ height: '500px' }} /> :
            <TicketPreview
              eventId={eventId}
              isShowModal={isShowModal}
              handleToggleModal={handleToggleModal}
              upPartsData={upPartsData}
              partsData={partsData}
              theme={theme}
              eventDetail={props.eventDetail || context.eventDetail}
              eventContext={context}
            />
          }

          {isShowEditModal &&
            <EventPageTicketPreviewEditMenuModal
              isOpen={isShowEditModal}
              handleShowModal={handleToggleEditModal}
              partsData={partsData}
              eventId={eventId}
              upPartsData={upPartsData}
            />
          }

          {isShowThemeModal &&
            <EventPageTicketPreviewThemeModal
              isOpen={isShowThemeModal}
              handleShowModal={handleToggleThemeModal}
              theme={theme}
              upThemeData={upThemeData}
              eventId={_.get(props, 'eventDetail.id', eventId)}
              onThemeUpdate={(): any => context.handleUpdateData && context.handleUpdateData()}
            />
          }
        </div>
      </div>

      {isShowStripeWarning && !_.isNull(isCheckStripeConnection) && !isCheckStripeConnection ?
        <StripeConnectWarningDialog
          handleShow={handleShowStripeWarning}
          callback={confirmStripeWarn}
        /> :
      null}
    </>
  );
};

export default withRouter(EventPageDesign);
